import React from 'react';
import { Grid, Typography } from '@mui/material';
import { RedTheme } from 'common/global';
import { fontWeightStyles } from 'TAP/styles/genericStyles/fontWeights';

const MyTeamProfileReadOnlyPopupUserProfile = ({ params }) => {
  const theme = RedTheme;
  const NO_DATA_DAS = `-`;

  const labelTypoGraphyStyle = {
    fontSize: '14px',
    fontFamily: '"JohnsonText-Medium"',
    fontStyle: 'normal',
    fontWeight: fontWeightStyles.fw5.fontWeight,
    color: theme.palette.text.lightCaption,
  };
  const labelDataStyle = {
    fontFamily: '"JohnsonText-Regular"',
    fontWeight: fontWeightStyles.fw4.fontWeight,
    color: theme.palette.text.base,
  };

  return (
    <Grid container spacing={4} marginTop={3}>
      <Grid item xs={4} sm={4} md={4}>
        <Typography sx={labelTypoGraphyStyle}>{'Job Title:'}</Typography>
        <Typography sx={labelDataStyle}>{params.job_title || NO_DATA_DAS}</Typography>
      </Grid>
      <Grid item xs={4} sm={4} md={4}>
        <Typography sx={labelTypoGraphyStyle}>{'Worker Type:'}</Typography>
        <Typography sx={labelDataStyle}>{params.worker_type || NO_DATA_DAS}</Typography>
      </Grid>
      <Grid item xs={4} sm={4} md={4}>
        <Typography sx={labelTypoGraphyStyle}>{'Partner Company:'}</Typography>
        <Typography sx={labelDataStyle}>{params.partner_company || NO_DATA_DAS}</Typography>
      </Grid>
      <Grid item xs={4} sm={4} md={4}>
        <Typography sx={labelTypoGraphyStyle}>{'Country:'}</Typography>
        <Typography sx={labelDataStyle}>{params.country_name || NO_DATA_DAS}</Typography>
      </Grid>
      <Grid item xs={4} sm={4} md={4}>
        <Typography sx={labelTypoGraphyStyle}>{'Organization:'}</Typography>
        <Typography sx={labelDataStyle}>{params?.organization || NO_DATA_DAS}</Typography>
      </Grid>
      <Grid item xs={4} sm={4} md={4}>
        <Typography sx={labelTypoGraphyStyle}>{'Function:'}</Typography>
        <Typography sx={labelDataStyle}>{params?.function || NO_DATA_DAS}</Typography>
      </Grid>
      <Grid item xs={4} sm={4} md={4}>
        <Typography sx={labelTypoGraphyStyle}>{'Sub Function:'}</Typography>
        <Typography sx={labelDataStyle}>{params?.sub_function || NO_DATA_DAS}</Typography>
      </Grid>
      <Grid item xs={4} sm={4} md={4}>
        <Typography sx={labelTypoGraphyStyle}>{'Specialization:'}</Typography>
        <Typography sx={labelDataStyle}>{params?.specialization || NO_DATA_DAS}</Typography>
      </Grid>
      <Grid item xs={4} sm={4} md={4}>
        <Typography sx={labelTypoGraphyStyle}>{'Sub Specialization:'}</Typography>
        <Typography sx={labelDataStyle}>{params?.sub_specialization || NO_DATA_DAS}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography sx={labelTypoGraphyStyle}>{'Role:'}</Typography>
        <Typography sx={labelDataStyle}>{params?.job_role || NO_DATA_DAS}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography sx={labelTypoGraphyStyle}>{'Additional/Optional Curricula:'}</Typography>
        <Typography sx={labelDataStyle}>{params?.additional_curriculla || NO_DATA_DAS}</Typography>
      </Grid>
    </Grid>
  );
};

export default MyTeamProfileReadOnlyPopupUserProfile;
